<template>
  <div class="question-list">
    <div class="head">
      <div class="total">
        {{
          `单选${radioList.length}道，多选${checkboxList.length}道，合计${
            radioList.length + checkboxList.length
          }道  满分${grossScore}分`
        }}
      </div>
      <div>
        <el-button class="head-button" type="primary" @click="gotoAddQuestion">添加题目</el-button>
        <el-button
          class="head-button"
          type="primary"
          @click="rowDropNotice"
          :disabled="checkboxList.length < 2 && radioList.length < 2"
          v-if="!dragNoticeList"
        >
          排序
        </el-button>
        <el-button
          class="head-button"
          type="primary"
          @click="closeRowDropNotice"
          v-if="dragNoticeList"
        >
          取消排序
        </el-button>
      </div>
    </div>
    <div class="show-list" v-if="radioList.length">
      <div class="topline">
        <div>一、单选</div>
        <div class="type-credit">
          每道单选题的分值：
          <el-input
            placeholder="输入分值"
            type="number"
            v-model="radioValue"
            @change="handleAllRadio"
            @keydown.native="channelInputLimit"
            :max="99"
            :min="0"
          />
        </div>
      </div>
      <div class="radio-draggable-box">
        <div class="question-box" v-for="(item, index) in radioList" :key="item.question_id">
          <div class="title">
            {{ `${index + 1}.${item.question_name}` }}
            <el-button
              type="text"
              @click="deleteQuestion('radio', index)"
              :disabled="dragNoticeList"
            >
              删除
            </el-button>
          </div>
          <div class="content">
            <div class="option" v-for="option in item.question_options" :key="option.option_label">
              {{ `${option.option_label}.${option.option_content}` }}
              <img class="option-image" :src="option.pic_url" v-if="option.pic_url" />
            </div>
          </div>
          <div class="credit">
            分值：
            <el-input
              placeholder="输入分值"
              type="number"
              v-model="item.question_value"
              @change="handleRadio(item)"
              @keydown.native="channelInputLimit"
              :max="99"
              :min="0"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="show-list" v-if="checkboxList.length">
      <div class="topline">
        <div>{{ radioList.length ? '二' : '一' }}、多选</div>
        <div class="type-credit">
          每道多选题的分值：
          <el-input
            placeholder="输入分值"
            type="number"
            v-model="checkboxValue"
            @change="handleAllCheckbox"
            @keydown.native="channelInputLimit"
            :max="99"
            :min="0"
          />
        </div>
      </div>
      <div class="checkbox-draggable-box">
        <div class="question-box" v-for="(item, index) in checkboxList" :key="item.question_id">
          <div class="title">
            {{ `${index + 1}.${item.question_name}` }}
            <el-button
              type="text"
              @click="deleteQuestion('checkbox', index)"
              :disabled="dragNoticeList"
            >
              删除
            </el-button>
          </div>
          <div class="content">
            <div class="option" v-for="option in item.question_options" :key="option.option_label">
              {{ `${option.option_label}.${option.option_content}` }}
              <img class="option-image" :src="option.pic_url" v-if="option.pic_url" />
            </div>
          </div>
          <div class="credit">
            分值：
            <el-input
              placeholder="输入分值"
              type="number"
              v-model="item.question_value"
              @change="handleCheckbox(item)"
              @keydown.native="channelInputLimit"
              :max="99"
              :min="0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sortable from 'sortablejs';
import { lstore } from '@/libs/utils/util';
import { GetQuestionDetailById } from '@/api/exam.js';
export default {
  name: 'QuestionList',
  props: {
    qList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      dragNoticeList: false,
      radioList: [],
      checkboxList: [],
      selectedQuestionIdList: [],
      paper_id: this.$route.query.paper_id,
      type: this.$route.query.type,
      checkboxValue: 0,
      radioValue: 0,
      handleAllRadioFlag: false,
      handleAllCheckboxFlag: false,
      maxCredit: 99,
    };
  },
  computed: {
    grossScore() {
      const grossScore =
        this.radioList.reduce((acc, cur) => acc + Number(cur.question_value), 0) +
        this.checkboxList.reduce((acc, cur) => acc + Number(cur.question_value), 0);
      this.$emit('setGrossScore', grossScore);
      return grossScore;
    },
  },
  mounted() {
    this.init();
    // 解决火狐浏览器下拖拽题目打开新页面问题
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },
  methods: {
    // 初始化
    init() {
      if (this.qList.length > 0 && this.type !== 'back') {
        this.questionFilter(this.qList);
        this.paperToQuestions = { ids: [], values: {} };
      } else {
        // 读取localStorage中的已选题目（如果有的话）
        this.paperToQuestions = lstore.getItem('exam-paper-add-question-ids') || {};
        const ids = this.paperToQuestions.ids || [];
        GetQuestionDetailById({ question_id: ids }).then((res) => {
          for (const item of res.question_detail) {
            if (item.question_id in this.paperToQuestions.values) {
              item.question_value = this.paperToQuestions.values[item.question_id];
            }
          }
          res.question_detail = this.sortQuestion(ids, res.question_detail);
          for (const item of res.question_detail) {
            if (item.question_type === 1) {
              this.radioList.push(item);
            } else if (item.question_type === 2) {
              this.checkboxList.push(item);
            }
          }
        });
      }
    },
    sortQuestion(idList, questionList) {
      const result = [];
      for (const id of idList) {
        for (let j = 0; j < questionList.length; j++) {
          if (questionList[j].question_id === id) {
            result.push(questionList[j]);
            questionList.splice(j, 1);
          }
        }
      }
      return result;
    },
    qListToIds() {
      const radioIds = [];
      const checkboxIds = [];
      const values = {};
      for (const item of this.radioList) {
        radioIds.push(item.question_id);
        values[item.question_id] = item.question_value;
      }
      for (const item of this.checkboxList) {
        checkboxIds.push(item.question_id);
        values[item.question_id] = item.question_value;
      }
      this.paperToQuestions.ids = radioIds.concat(checkboxIds);
      this.paperToQuestions.values = values;
      lstore.setItem('exam-paper-add-question-ids', this.paperToQuestions);
    },
    deleteQuestion(type, index) {
      if (type === 'radio') {
        this.radioList.splice(index, 1);
      } else if (type === 'checkbox') {
        this.checkboxList.splice(index, 1);
      }
      this.qListToIds();
    },
    questionFilter(qList) {
      for (const item of qList) {
        if (item.question_type === 1) {
          this.radioList.push(item);
        } else if (item.question_type === 2) {
          this.checkboxList.push(item);
        }
      }
    },
    handleAllRadio(value) {
      if (value > this.maxCredit) this.radioValue = 99;
      for (const item of this.radioList) {
        item.question_value = this.radioValue;
      }
      this.handleAllRadioFlag = true;
    },
    handleAllCheckbox(value) {
      if (value > this.maxCredit) this.checkboxValue = 99;
      for (const item of this.checkboxList) {
        item.question_value = this.checkboxValue;
      }
      this.handleAllCheckboxFlag = true;
    },
    handleRadio(item) {
      if (this.handleAllRadioFlag) {
        this.$message('批量设置的单选题分值已失效');
        this.handleAllRadioFlag = false;
      }
      if (item.question_value > this.maxCredit) {
        // eslint-disable-next-line no-param-reassign
        item.question_value = 99;
      }
    },
    handleCheckbox(item) {
      if (this.handleAllCheckboxFlag) {
        this.$message('批量设置的多选题分值已失效');
        this.handleAllCheckboxFlag = false;
      }
      if (item.question_value > this.maxCredit) {
        // eslint-disable-next-line no-param-reassign
        item.question_value = 99;
      }
    },
    rowDropNotice() {
      // 拖动事件
      this.dragNoticeList = true;
      if (this.dragNoticeList) {
        const tbody = document.querySelectorAll('.radio-draggable-box');
        if (tbody.length) {
          const _this = this;
          this.dragDorpRadio = Sortable.create(tbody[0], {
            onEnd({ newIndex, oldIndex }) {
              const currRow = _this.radioList.splice(oldIndex, 1)[0];
              _this.radioList.splice(newIndex, 0, currRow);
            },
          });
        }
      }
      if (this.dragNoticeList) {
        const tbody = document.querySelectorAll(`.checkbox-draggable-box`);
        if (tbody.length) {
          const _this = this;
          this.dragDorpCheckbox = Sortable.create(tbody[0], {
            onEnd({ newIndex, oldIndex }) {
              const currRow = _this.checkboxList.splice(oldIndex, 1)[0];
              _this.checkboxList.splice(newIndex, 0, currRow);
            },
          });
        }
      }
    },
    closeRowDropNotice() {
      this.dragNoticeList = false;
      if (this.dragDorpRadio) this.dragDorpRadio.destroy();
      if (this.dragDorpCheckbox) this.dragDorpCheckbox.destroy();
    },
    gotoAddQuestion() {
      this.qListToIds();
      this.$emit('saveChange');
      this.$emit('changeComponent', 'addQuestion', { paper_id: this.paper_id });
    },
    channelInputLimit(e) {
      const { key } = e;
      const ban = ['e', 'E', '.', '+', '-'];
      if (ban.includes(key)) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    getRadioList() {
      return this.radioList.map((item, index) => {
        const { question_id, question_value } = item;
        return {
          question_id,
          question_order: index,
          question_value: Number(question_value),
        };
      });
    },
    getCheckboxList() {
      return this.checkboxList.map((item, index) => {
        const { question_id, question_value } = item;
        return {
          question_id,
          question_order: index + this.radioList.length,
          question_value: Number(question_value),
        };
      });
    },
    getCredit() {
      let credit = 0;
      this.checkboxList.forEach((item) => {
        credit += Number(item.question_value);
      });
      this.radioList.forEach((item) => {
        credit += Number(item.question_value);
      });
      return credit;
    },
    isEmpty() {
      return !(this.radioList.length || this.checkboxList.length);
    },
    removeLstore() {
      lstore.removeItem('exam-paper-add-question-ids');
    },
  },
};
</script>
<style scoped lang="scss">
.question-list {
  width: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border-top: solid 1px #edeff2;
  border-bottom: solid 1px #edeff2;
  padding: 20px 0 20px 0;
  color: #313233;
  letter-spacing: 0;
  text-align: left;
  .head {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .total {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      line-height: 24px;
    }
    .head-button {
      width: 100px;
      margin-right: 20px;
    }
  }
  .show-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    line-height: 22px;
    margin-top: 24px;
    .topline {
      display: flex;
      align-items: center;
    }
    .question-box {
      color: #626366;
      padding-bottom: 10px;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;
        margin: 10px 0 8px 0;
        .el-button {
          padding: 0;
        }
      }
      .content {
        .option {
          margin: 4px 0 4px 0;
          .option-image {
            width: 300px;
            display: block;
          }
        }
      }
    }
  }
}
::v-deep.type-credit {
  margin-left: 48px;
  .el-input {
    display: inline;
  }
  .el-input__inner {
    width: 100px;
  }
}
::v-deep.credit {
  margin-top: 4px;
  .el-input {
    display: inline;
    .el-input__inner {
      width: 100px;
    }
  }
}
</style>
